'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ImageHeadline = function (_React$Component) {
  _inherits(ImageHeadline, _React$Component);

  function ImageHeadline(props) {
    _classCallCheck(this, ImageHeadline);

    var _this = _possibleConstructorReturn(this, (ImageHeadline.__proto__ || Object.getPrototypeOf(ImageHeadline)).call(this, props));

    _this.enableImage = function () {
      window.removeEventListener('resize', _this.handleResize);
      window.removeEventListener('scroll', _this.handleScroll);

      _this.setState({ showImage: true });
    };

    _this.handleResize = function () {
      var domRect = _this.divElement && _this.divElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        _this.enableImage();
      }
    };

    _this.handleScroll = function () {
      _this.enableImage();
    };

    _this.renderImage = function (image) {
      if (image && image.src && _this.state.showImage) {
        return _react2.default.createElement('img', { src: image.src, alt: image.alt, className: 'image-headline__image' });
      }
      return null;
    };

    _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _heading2.default,
          { level: '3', className: 'image-headline__headline pp-sans-small-regular h4' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    };

    _this.state = {
      showImage: false
    };
    return _this;
  }

  _createClass(ImageHeadline, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // if components in view, then enable icons; otherwise add listeners
      var domRect = this.divElement && this.divElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImage();
      } else {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    // once enableIcon() is called, there is no need to listen anymore


    // if after window resize and the component is in view, then enable icons,
    // otherwise do nothing

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$content = this.props.content,
          image = _props$content.image,
          headline = _props$content.headline;


      var moleculeClasses = (0, _classnames2.default)('image-headline', this.props.className);

      return _react2.default.createElement(
        'div',
        {
          className: moleculeClasses,
          ref: function ref(el) {
            _this2.divElement = el;
          }
        },
        this.renderImage(image),
        this.renderHeadline(headline)
      );
    }
  }]);

  return ImageHeadline;
}(_react2.default.Component);

exports.default = ImageHeadline;


ImageHeadline.propTypes = {
  content: _propTypes2.default.shape({
    image: _propTypes2.default.shape({
      src: _propTypes2.default.string.isRequired,
      alt: _propTypes2.default.string
    }),
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }),
  className: _propTypes2.default.string
};

ImageHeadline.defaultProps = {
  content: {
    headline: {
      text: '44 characters maximum'
    },
    image: {
      src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/au/icons/AU-icon-payflow-green.svg',
      alt: ''
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/image-headline/jsx/ImageHeadline.js
// module id = 666
// module chunks = 4